import styled from "styled-components";
import { Link } from "react-router";

import error from "../../assets/images/error.png";
import { Typography } from "../atoms/Typography";

/**
 * 存在しないページ
 */

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    margin-top: 80px;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 50px;
`;

const StyledLink = styled(Link)`
  cursor: pointer;
  width: 100%;
  max-width: 400px;
  height: 44px;
  background-color: ${(props) => props.theme.colors.brand};
  text-decoration: none;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.colors.secondaryText};
`;

export function NotFoundPage() {
  return (
    <Container>
      <img src={error} width="300" height="300" alt={"error"} />
      <TitleWrapper>
        <Typography size={6} bold>
          存在しないページです
        </Typography>
      </TitleWrapper>
      {/*画面遷移*/}
      <StyledLink to={""}>
        <Typography size={2} bold>
          TOPページにもどる
        </Typography>
      </StyledLink>
    </Container>
  );
}
